// DS: i1.19
// DS: VideoCreator
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const VideoCreator: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 30" fill="none">
        <path
          fill="currentColor"
          d="M27.515 6.018c.953.081 1.983.767 1.984 1.949v16.071c0 1.262-1.173 1.958-2.174 1.958H9.675c-1 0-2.175-.695-2.175-1.958v-7.242a1 1 0 0 1 2 0v7.156a.35.35 0 0 0 .176.044h17.648a.35.35 0 0 0 .175-.043v-15.9a.3.3 0 0 0-.101-.037l-.074-.006H17.5a1 1 0 1 1 0-2h9.825z"
        />
        <path
          fill="currentColor"
          d="M16.621 12c.2 0 .396.049.568.139l5.307 3.25.11.064c.447.302.578.862.288 1.304a1.1 1.1 0 0 1-.398.354l-5.307 3.251-.117.053c-.513.202-1.126.034-1.418-.407a.92.92 0 0 1-.154-.508V13l.008-.116c.065-.497.539-.884 1.113-.884M8.167 2a.13.13 0 0 1 .118.114c.585 2.89 2.246 4.715 5.403 5.22a.13.13 0 0 1 .116.096q.001.006.004.012v.036l-.002.01a.13.13 0 0 1-.117.1c-3.158.506-4.82 2.33-5.404 5.222a.13.13 0 0 1-.126.113h-.017a.13.13 0 0 1-.119-.114c-.583-2.89-2.246-4.715-5.402-5.22a.13.13 0 0 1-.116-.097l-.003-.01v-.003l-.002-.01v-.02l.002-.004v-.01a.13.13 0 0 1 .118-.1c3.158-.504 4.82-2.331 5.403-5.223A.13.13 0 0 1 8.14 2z"
        />
      </svg>
    </IconWrap>
  );
};
VideoCreator.displayName = 'VideoCreator';

export default VideoCreator;
